import { ankrMethods } from './ankr.js';
import { blockchairMethods } from './blockchair.js';
import { blockcypherMethods } from './blockcypher.js';
import { mempoolMethods } from './mempool.js';
export function getRpcProviderMethods(key) {
    switch (key) {
        case 'blockchair':
            return blockchairMethods;
        case 'ankr':
            return ankrMethods;
        case 'blockcypher':
            return blockcypherMethods;
        case 'mempool':
            return mempoolMethods;
        default:
            return null;
    }
}
//# sourceMappingURL=getRpcProviderMethods.js.map